import { render, staticRenderFns } from "./ActivarMedidorComponent.vue?vue&type=template&id=f2464e60&"
import script from "./ActivarMedidorComponent.vue?vue&type=script&lang=js&"
export * from "./ActivarMedidorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSwitch,VTooltip})
